(function () {
  const details = document.querySelectorAll('.contact-faq-grid details');
  if (!details.length) return;

  details.forEach(function (el) {
    el.addEventListener('toggle', function () {
      if (!el.open) return;
      details.forEach(function (other) {
        if (other !== el && other.open) other.removeAttribute('open');
      });
    });

    const summary = el.querySelector('summary');
    if (summary) {
      summary.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          el.open = !el.open;
          el.dispatchEvent(new Event('toggle'));
        }
      });
    }
  });

  const jumpLinks = document.querySelectorAll('[data-contact-jump]');
  jumpLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      const target = document.getElementById(link.dataset.contactJump);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
})();
